import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=2f2bd207&scoped=true&"
import script from "./SocialNetwork.vue?vue&type=script&lang=js&"
export * from "./SocialNetwork.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetwork.vue?vue&type=style&index=0&id=2f2bd207&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bd207",
  null
  
)

export default component.exports